export const GET_OFFERS_QUERY = `
  query OfferFindMany($filter: FilterFindManyOfferInput, $limit: Int) {
    OfferFindMany(filter: $filter, limit: $limit) {
      _id
      name
      status
      url
      affiliate
      category
    }
  }
`;

export const fetchOffers = async (filter: any, limit = 50) => {
  const { API_V2 } = await import('@/src/lib/axios');
  
  const { data: result } = await API_V2.post('graphql', {
    query: GET_OFFERS_QUERY,
    variables: { filter, limit },
  });

  if (result.errors) {
    throw result.errors[0];
  }
  
  return result.data?.OfferFindMany || [];
};
